export default "__VITE_PUBLIC_ASSET__64fd79fc__"